import React from 'react'
import PropTypes from 'prop-types';
import _ from 'lodash'

import I18n from 'PMT/i18n/I18n'

const Graph = ({ graphId, name, filters, filtersState, changeFilters }) => (
  <div className="panel panel-default">
    <div className="panel-heading">
      <i className="fa fa-bar-chart-o fa-fw"></i> {name}
      {!_.isEmpty(filters) && !_.isNull(changeFilters) &&
        <div className="pull-right">
          <div className="btn-group" data-toggle="buttons">
            {_.keys(filters).map((filter) => (
              <label
                className={`btn btn-xs ${filtersState.includes(filter) ? 'btn-primary': 'btn-default'}`}
                onClick={() => changeFilters(filter)}
              >
                {filters[filter].label}
              </label>
            ))}
          </div>
        </div>
      }
    </div>
    <div className="panel-body">
      <div id={graphId}></div>
    </div>
  </div>
)

Graph.propTypes = {
  graphId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  filters: PropTypes.object,
  filtersState: PropTypes.array,
  changeFilters: PropTypes.function,
}

export default Graph
